package ai.flowstorm.studio.ui

class RootReportPanel : ReportPanel(false)